import {useAppDispatch} from '../../../hooks/redux'
import {closeModal} from '../../../redux/features/modal'

import {ModalMeta} from '../../../types'

import Button from '../../../../../commons/src/components/button'
import Headline from '../../../../../commons/src/components/headline'
import Modal from '../../../../../commons/src/components/modal'
import Paragraph from '../../../../../commons/src/components/paragraph'

type Props = {
  meta: ModalMeta
  count: number
  onConfirm: () => void
  onCancel: () => void
}

const SuggestImmediateEditingModal = ({meta, count, onConfirm, onCancel}: Props) => {
  const dispatch = useAppDispatch()

  return (
    <Modal
      fullscreenMobile={meta.fullscreenMobile}
      headline={<Headline label="Set up material configuration" size="l" />}
      onClose={() => dispatch(closeModal())}
      buttons={
        <>
          <Button
            hierarchy="ghost"
            onClick={() => {
              onCancel()
              dispatch(closeModal())
            }}
          >
            Later
          </Button>
          <Button
            onClick={() => {
              onConfirm()
              dispatch(closeModal())
            }}
          >
            Edit now
          </Button>
        </>
      }
    >
      <Paragraph>
        {`Would you like to edit your ${count} new material configuration(s) now or later?`}
      </Paragraph>
    </Modal>
  )
}

export default SuggestImmediateEditingModal
